// extracted by mini-css-extract-plugin
export default {"triangle":"Stx0jQ","with-url":"a57zfJ","withUrl":"a57zfJ","icon":"QGSdt1","icon-scheduled":"uew8AY","iconScheduled":"uew8AY"};